module.exports = __webpack_public_path__ + "static/media/Astronomy.2db25de0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/subject_icons/Astronomy.svg
// module id = 874
// module chunks = 21